import { ErrorEventDetails } from './types';
export function pushErrorEventToDataLayer(error: ErrorEventDetails): void {
  if (typeof window === 'undefined') return;
  if (!Array.isArray((window as any).dataLayer)) return;
  const {
    error_type,
    error_code,
    error_description,
    error_category,
    error_location,
    page_url,
    error_object
  } = error;
  const amplitudeError = {
    event: 'Precision_Event',
    event_type: 'Error Occurred', 
    event_properties: {
      error_type,
      error_code,
      error_description,
      error_category,
      error_location,
      page_url: page_url ?? window.location.pathname
    } 
  } as any;

  if (error_object) {
    amplitudeError.error_object = JSON.stringify(
      error_object,
      Object.getOwnPropertyNames(error_object)
    );
  }

  (window as any).dataLayer.push(amplitudeError);
}
